// extracted by mini-css-extract-plugin
export default {"featureLogoSectionWrapper":"FeatureLogosPrint_featureLogoSectionWrapper__gx-LT","logoWrapper":"FeatureLogosPrint_logoWrapper__JPJa8","logo":"FeatureLogosPrint_logo__WptRf"};